module.exports = __webpack_public_path__ + "static/media/ic-share.6c935b70.svg";